import { render, staticRenderFns } from "./BroadcastNotifications.vue?vue&type=template&id=060b5d3e&"
import script from "./BroadcastNotifications.vue?vue&type=script&lang=js&"
export * from "./BroadcastNotifications.vue?vue&type=script&lang=js&"
import style0 from "./BroadcastNotifications.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports